/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { useIsFetching, useIsMutating } from '@tanstack/react-query';
import { GlobalProgressBar } from '@vaas/react-ui-kit';
import { useTranslation } from 'react-i18next';

/**
 * Hairline at the top of the viewport for work that shouldn't take the page away: background
 * refetches, saves, and any query without a local placeholder.
 *
 * The bar and its show/hide debounce (400ms before showing, 150ms tail before hiding) are the
 * kit's `GlobalProgressBar`, on the `--z-progress` layer. What stays here is the predicate - what
 * this app counts as "busy" - which is a product decision, and React Query a dependency the kit
 * deliberately does not take. Its own component so the fetch counters re-render two pixels of
 * chrome instead of the whole shell.
 */
export function GlobalProgress() {
  const { t } = useTranslation();
  const busy = useIsFetching() + useIsMutating() > 0;
  return <GlobalProgressBar active={busy} label={t('common.loading')} />;
}
